"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlignPopupClassName = exports.getAlignFromPlacement = void 0;
var tslib_1 = require("tslib");
function isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) {
        return a1[0] === a2[0];
    }
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return tslib_1.__assign(tslib_1.__assign({}, baseAlign), align);
}
exports.getAlignFromPlacement = getAlignFromPlacement;
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for (var i = 0; i < placements.length; i += 1) {
        var placement = placements[i];
        if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
            return "".concat(prefixCls, "-placement-").concat(placement);
        }
    }
    return '';
}
exports.getAlignPopupClassName = getAlignPopupClassName;
//# sourceMappingURL=alignUtil.js.map